import { useEffect, useState, useCallback } from "react"
import {apiV2} from "@/api/axiosConfig";
import {CustomUserField} from "@/features/management-v2/custom-user-fields/types";

type UseCustomUserFieldsReturn = {
    fields: CustomUserField[]
    loading: boolean
    error: Error | null
    refresh: () => Promise<void>
}

export function useCustomUserFields(clientID?: string): UseCustomUserFieldsReturn {
    const [fields, setFields] = useState<CustomUserField[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    const fetchFields = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const url = clientID
                ? `/custom-user-fields/${clientID}`
                : "/custom-user-fields"

            const response = await apiV2.get<CustomUserField[]>(url)

            setFields(response.data ?? [])
        } catch (err) {
            setError(err as Error)
            setFields([])
        } finally {
            setLoading(false)
        }
    }, [clientID])

    useEffect(() => {
        fetchFields()
    }, [fetchFields])

    return {
        fields,
        loading,
        error,
        refresh: fetchFields
    }
}